/* eslint-disable space-in-parens */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Setting from '../../containers/SettingContainer'
import LoadingBar from 'react-redux-loading-bar'
import ReactGA from 'react-ga'
import { Helmet } from 'react-helmet'
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap'

class HeaderMenuTest extends React.Component {
  static propTypes = {
    posts: PropTypes.array,
    fetchPostsWithRedux: PropTypes.func,
  }
  componentDidMount () {
    this.props.fetchPostsWithRedux()
    ReactGA.initialize(Setting.analyticsUA)
    ReactGA.pageview(window.location.pathname + window.location.search)
    console.log(this.props)
  }

  componentDidUpdate (prevProps, prevState) {
  }

  render () {
    const pStyle1 = {
      height: '97px',
      marginLeft: '0px',
      backgroundColor: 'transparent',
      borderColor: 'transparent'
    }
    const pStyle2 = {
      height: '97px',
      marginLeft: '0px',
      backgroundColor: 'transparent',
      paddingTop: '23px',
      borderColor: 'transparent'
    }
    const marginLogo = {
      marginTop: '-27px'
    }
    const notDot = {
      listStyleType: 'none'
    }

    const rbTop = {
      right: '5px',
      bottom: '5px'
    }

    return (
      <div>
        <Helmet>
          <script type='text/javascript' src='/lib/jquery.js' />
          <script type='text/javascript' src='/lib/bootstrrap.min.js' />
          <script type='text/javascript' src='/lib/custom.js' />
          <script type='text/javascript' src='/lib/pushnotification.js' />
        </Helmet>
        <button className='btn scrolltop-btn back-top' style={rbTop}>
          <i className='fa fa-angle-up' />
        </button>
        <div className='modal fade' id='pop-login' tabIndex='-1' role='dialog'>
          <div className='modal-dialog modal-sm'>
            <div className='modal-content'>
              <div className='modal-header'>
                <ul className='login-tabs'>
                  <li className='active'>Login</li>
                  <li>Register</li>
                </ul>
                <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                  <i className='fa fa-close' />
                </button>
              </div>
              <div className='modal-body login-block'>
                <div className='tab-content'>
                  <div className='tab-pane fade in active'>
                    <div className='message'>
                      <p className='error text-danger'><i className='fa fa-close' /> You are not Logedin</p>
                      <p className='success text-success'><i className='fa fa-check' /> You are not Logedin</p>
                    </div>
                    <form>
                      <div className='form-group field-group'>
                        <div className='input-user input-icon'>
                          <input type='text' placeholder='Username' />
                        </div>
                        <div className='input-pass input-icon'>
                          <input type='password' placeholder='Password' />
                        </div>
                      </div>
                      <div className='forget-block clearfix'>
                        <div className='form-group pull-left'>
                          <div className='checkbox'>
                            <label>
                              <input type='checkbox' />
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className='form-group pull-right'>
                          <a href='#' data-toggle='modal' data-dismiss='modal' data-target='#pop-reset-pass'>
                            I forgot username and password
                          </a>
                        </div>
                      </div>

                      <button type='submit' className='btn btn-primary btn-block'>Login</button>
                    </form>
                    <hr />
                    <a href='#' className='btn btn-social btn-bg-facebook btn-block'>
                      <i className='fa fa-facebook' /> login with facebook</a>
                    <a href='#' className='btn btn-social btn-bg-linkedin btn-block'>
                      <i className='fa fa-linkedin' /> login with linkedin</a>
                    <a href='#' className='btn btn-social btn-bg-google-plus btn-block'>
                      <i className='fa fa-google-plus' /> login with Google</a>
                  </div>
                  <div className='tab-pane fade'>
                    <form>
                      <div className='form-group field-group'>
                        <div className='input-user input-icon'>
                          <input type='text' placeholder='Username' />
                        </div>
                        <div className='input-email input-icon'>
                          <input type='email' placeholder='Email' />
                        </div>
                      </div>
                      <div className='form-group'>
                        <div className='checkbox'>
                          <label>
                            <input type='checkbox' />
                            I agree with your <a href='#'>Terms & Conditions</a>.
                          </label>
                        </div>
                      </div>
                      <button type='submit' className='btn btn-primary btn-block'>Register</button>
                    </form>
                    <hr />

                    <a href='#' className='btn btn-social btn-bg-facebook btn-block'>
                      <i className='fa fa-facebook' />
                      login with facebook
                    </a>
                    <a href='#' className='btn btn-social btn-bg-linkedin btn-block'>
                      <i className='fa fa-linkedin' />
                      login with linkedin
                    </a>
                    <a href='#' className='btn btn-social btn-bg-google-plus btn-block'>
                      <i className='fa fa-google-plus' />
                      login with Google
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='modal fade' id='pop-reset-pass' tabIndex='-1' role='dialog'>
          <div className='modal-dialog modal-sm'>
            <div className='modal-content'>
              <div className='modal-header'>
                <ul className='login-tabs'>
                  <li className='active'>Reset Password</li>
                </ul>
                <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                  <i className='fa fa-close' />
                </button>
              </div>
              <div className='modal-body'>
                <p>
                  Please enter your username or email address.
                  You will receive a link to create a new password via email.
                </p>
                <form>
                  <div className='form-group'>
                    <div className='input-user input-icon'>
                      <input placeholder='Enter your username or email' className='form-control' />
                    </div>
                  </div>
                  <button className='btn btn-primary btn-block'>Get new password</button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <header id='header-section'
          className='header-section-4 header-main  nav-left hidden-sm hidden-xs' data-sticky='1'>
          <div className='container' style={pStyle1}>
            <div className='header-left'>
              <nav className='navi main-nav'>
                <Navbar style={pStyle2}>
                  <Navbar.Header>
                    <Navbar.Brand>
                      <Link to='/trang-chu'><img style={marginLogo} src={Setting.logo} alt='logo' /></Link>
                    </Navbar.Brand>
                  </Navbar.Header>
                  <Nav>
                    {this.props.posts && this.props.posts.map( (header, iKey) => {
                      if ( header.submenus !== null ) {
                        const subMenu = header.submenus.map((subheader, subKey) => {
                          const items = subheader.items.map((litheader, litKey) => {
                            return (<MenuItem eventKey={litKey} key={litKey} href={litheader.url}>
                              {litheader.name}</MenuItem>)
                          })

                          return (<NavDropdown eventKey={subKey} key={subKey} title={subheader.subname}
                            id='basic-nav-dropdown'>
                            {items}
                          </NavDropdown>)
                        })
                        return (subMenu)
                      }
                      return (
                        <NavItem eventKey={iKey} key={iKey} href={header.url}>
                          {header.name}
                        </NavItem>
                      )
                    })}

                  </Nav>
                </Navbar>
                <LoadingBar />
              </nav>
            </div>
            <div className='header-right'>
              <div className='user'>
                <a href={'tel:' + Setting.phone} className='btn btn-default'>
                  <i className='fa fa-phone' />
                  {Setting.phone}
                </a>
              </div>
            </div>
          </div>
        </header>
        <div className='header-mobile visible-sm visible-xs'>
          <LoadingBar />
          <div className='container'>
            <div className='mobile-nav'>
              <NavDropdown style={notDot} eventKey={10} title={<span className='nav-trigger'>
                <i className='fa fa-navicon' /></span>} id='basic-nav-dropdown'>
                {this.props.posts && this.props.posts.map( (header, iKey) => {
                  if ( header.submenus !== null ) {
                    const subMenu = header.submenus.map((subheader, subKey) => {
                      const items = subheader.items.map((litheader, litKey) => {
                        return (<MenuItem eventKey={litKey} key={litKey} href={litheader.url}>
                          {litheader.name}</MenuItem>)
                      })
                      return (<NavDropdown eventKey={subKey} key={subKey} title={subheader.subname}
                        id='basic-nav-dropdown'>
                        {items}
                      </NavDropdown>)
                    })
                    return (subMenu)
                  }
                  return (
                    <NavItem eventKey={iKey} key={iKey} href={header.url}>
                      {header.name}
                    </NavItem>
                  )
                })}
              </NavDropdown>
            </div>
            <div className='header-logo'>
              <a href='/trang-chu'><img src={Setting.logo_white} alt='logo mobile' /></a>
            </div>
            <div className='header-user'>
              <ul className='account-action'>
                <li>
                  <a href={'tel:' + Setting.phone} className='user-icon'><i className='fa fa-phone' /></a>
                  {/*<div className='account-dropdown'>*/}
                    {/*<ul>*/}
                      {/*<li>*/}
                        {/*<a href='#' data-toggle='modal' data-target='#pop-login'>*/}
                          {/*<i className='fa fa-phone' />*/}
                          {/*{Setting.phone}*/}
                        {/*</a>*/}
                      {/*</li>*/}
                      {/*<li>*/}
                        {/*<a href='#' data-toggle='modal' data-target='#pop-login'>*/}
                          {/*<i className='fa fa-phone' />*/}
                          {/*{Setting.phone1}*/}
                        {/*</a>*/}
                      {/*</li>*/}
                    {/*</ul>*/}
                  {/*</div>*/}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HeaderMenuTest



// WEBPACK FOOTER //
// ./src/components/_partial/HeaderMenuTest.js